import React from 'react';
import { connect } from 'react-redux';
import ActionButton from '../../elements/ActionButton/ActionButton';
import SafeImage from '../../elements/SafeImage';
import Scrollable from '../../elements/Scrollable';
import SponsorsCarousel from '../../elements/SponsorsCarousel/SponsorsCarousel';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import LoadLocations from '../../loaders/LoadLocations';
import MeetingLocationsBlocklink from '../MeetingLocations/MeetingLocationsBlocklink';
import Screen from '../Screen';
import EventInfoContent from './EventInfoContent';

class EventInfoScreen extends React.Component {
    render() {
        var { event, i18n } = this.props;

        let header = (
            <div>
                <TopBarEvent event={event}>
                    {i18n['label.event.info']}
                </TopBarEvent>
                <hr />
            </div>
        );

        return (
            <Screen header={header}>
                <Scrollable>
                    <SafeImage
                        src={event.logo_url}
                        style={{
                            width: '100%',
                        }}
                    />
                    <hr />
                    <br />
                    <EventInfoContent event={event} />
                    <br />
                    <MeetingLocationsBlocklink eventId={event.id} />
                    {event.settings.url ? (
                        <ActionButton
                            className="margins"
                            next
                            secondary
                            onClick={this.handleOpenWebsite.bind(this)}
                        >
                            {i18n['label.Website']}
                        </ActionButton>
                    ) : null}
                    {event.sponsors ? (
                        <div className="marginTop marginBottom">
                            <SponsorsCarousel
                                eventId={event.id}
                                sponsors={event.sponsors}
                            />
                        </div>
                    ) : null}
                </Scrollable>
            </Screen>
        );
    }
    handleOpenWebsite() {
        window.open(this.props.event.settings.url, 'noopener,noreferrer');
    }
}

const StateConnectedEventInfoScreen = connect(function (state, props) {
    return {
        eventId: props.eventId,
        event: state.events[props.eventId].event,
        i18n: state.i18n.translations,
    };
})(EventInfoScreen);

export default (props) => (
    <LoadLocations eventId={props.match.params.eventId}>
        <StateConnectedEventInfoScreen {...props.match.params} />
    </LoadLocations>
);
